
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finance-solution",
      function () {
        return require("private-next-pages/finance-solution.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finance-solution"])
      });
    }
  